export default "__VITE_ASSET__2yLAssBZ__"